export default __webpack_public_path__ + "static/media/customTemplate.14c70f73.png";